import { render, staticRenderFns } from "./WarehouseLocationManagerDialog.vue?vue&type=template&id=56479975&scoped=true"
import script from "./WarehouseLocationManagerDialog.vue?vue&type=script&lang=js"
export * from "./WarehouseLocationManagerDialog.vue?vue&type=script&lang=js"
import style0 from "./WarehouseLocationManagerDialog.vue?vue&type=style&index=0&id=56479975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56479975",
  null
  
)

export default component.exports